/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StatsMitmItem } from './StatsMitmItem';
import {
    StatsMitmItemFromJSON,
    StatsMitmItemFromJSONTyped,
    StatsMitmItemToJSON,
} from './StatsMitmItem';

/**
 * 
 * @export
 * @interface GetStatsMitm200ResponseAllOf
 */
export interface GetStatsMitm200ResponseAllOf {
    /**
     * 
     * @type {Array<StatsMitmItem>}
     * @memberof GetStatsMitm200ResponseAllOf
     */
    result: Array<StatsMitmItem>;
}

/**
 * Check if a given object implements the GetStatsMitm200ResponseAllOf interface.
 */
export function instanceOfGetStatsMitm200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetStatsMitm200ResponseAllOfFromJSON(json: any): GetStatsMitm200ResponseAllOf {
    return GetStatsMitm200ResponseAllOfFromJSONTyped(json, false);
}

export function GetStatsMitm200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatsMitm200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(StatsMitmItemFromJSON)),
    };
}

export function GetStatsMitm200ResponseAllOfToJSON(value?: GetStatsMitm200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(StatsMitmItemToJSON)),
    };
}

